var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBurgerClose = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3 4.1C23.9627 3.43726 23.9627 2.36274 23.3 1.7C22.6373 1.03726 21.5627 1.03726 20.9 1.7L13.9142 8.68579C13.1332 9.46683 11.8668 9.46684 11.0858 8.68579L4.1 1.7C3.43726 1.03726 2.36274 1.03726 1.7 1.7C1.03726 2.36274 1.03726 3.43726 1.7 4.1L8.68579 11.0858C9.46684 11.8668 9.46684 13.1332 8.68579 13.9142L1.7 20.9C1.03726 21.5627 1.03726 22.6373 1.7 23.3C2.36274 23.9627 3.43726 23.9627 4.1 23.3L11.0858 16.3142C11.8668 15.5332 13.1332 15.5332 13.9142 16.3142L20.9 23.3C21.5627 23.9627 22.6373 23.9627 23.3 23.3C23.9627 22.6373 23.9627 21.5627 23.3 20.9L16.3142 13.9142C15.5332 13.1332 15.5332 11.8668 16.3142 11.0858L23.3 4.1Z",
    fill: "#113D18"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBurgerClose, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/burger-close.70dc3a3a.svg";
export { ForwardRef as ReactComponent };